import { useEffect } from "react"
import { useRouter } from "next/router"
import Head from "next/head"

import type { AppProps } from "next/app"
import type { ReactNode } from "react"

import "reset.css"
import "styles/globals.scss"

/**
 * Renders application root
 * @see https://nextjs.org/docs/advanced-features/custom-app
 * @param Component - route related component injection
 * @param pageProps - route related props
 */
export default function MyApp({ Component, pageProps }: AppProps): ReactNode {
  const router = useRouter()

  useEffect(() => { /** Preventing route change in editor */
      window.storyblok.pingEditor(({ inEditor }: any) => {
        if (inEditor) router.events.on('routeChangeStart', () => {
          router.events.emit('routeChangeError')
          throw 'Prevented route change in sb editor'
        })
      })
    }, [router.events])

  return <>
    <Head>
      <meta name="viewport" content="width=device-width, initial-scale=1"/>
      <link rel="apple-touch-icon" sizes="180x180" href="/icons/apple-touch-icon.png" />
      <link rel="icon" type="image/webp" sizes="32x32" href="/icons/favicon-32x32.webp" />
      <link rel="icon" type="image/webp" sizes="16x16" href="/icons/favicon-16x16.webp" />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="cannonical" href="/" />
    </Head>
    <Component {...pageProps} />
  </>
}
